import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiStar, HiClock } from 'react-icons/hi2';
import { useNavigate } from 'react-router-dom';
import Button from '../buttons/Button';

interface trialBannerProps {
  trialEndDate: Date
  plan: string;
  showPaymentSetup?: boolean;
  onPaymentSetup?: () => void;
}

export default function TrialBanner({
  trialEndDate, 
  plan,
  showPaymentSetup = true,
  onPaymentSetup
}: trialBannerProps): JSX.Element {
  const { t } = useTranslation('', { keyPrefix: 'component.trialBanner' });
  const navigate = useNavigate();
  
  const daysRemaining = Math.ceil((trialEndDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));

  return (
    <div className="mb-4 rounded-xl bg-primary-300 p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-900">
            <HiStar className="h-5 w-5 text-primary-300" />
          </div>
          <div>
            <h3 className="font-semibold text-primary-900">
              {t('title', { plan })}
            </h3>
            <div className="flex items-center gap-1 text-sm text-primary-900 opacity-80">
              <HiClock className="h-4 w-4" />
              <span>
                {daysRemaining > 1 
                  ? t('daysRemaining', { days: daysRemaining })
                  : t('lastDay')
                }
              </span>
            </div>
          </div>
        </div>
        
        {showPaymentSetup && (
          <div className="flex items-center gap-2">
            <Button
              variant="primary"
              onClick={onPaymentSetup || (() => navigate('/subscriptions/manage'))}
            >
              {t('upgradeNow')}
            </Button>
          </div>
        )}
      </div>
      
      <div className="mt-3 text-sm text-primary-900 opacity-90">
        {t('description', { plan })}
      </div>
    </div>
  );
}